// return fake json

import {
  kEXCLUDED,
  kEXPIRED,
  kFAILED,
  kPENDING,
  kSUCCESS,
  kUNANSWERED,
} from "./pages/review/ReviewStatusKeys";
import { EXCLUDE } from "./text-data";
import date2Str from "./utils/dateToStr";
import generateLatestSevenDays from "./utils/generateLatestSevenDays";

// api/v1/review/reviewList
export const review_reviewList = [
  {
    type: "PendingComments",
    number: 2,
  },
  {
    type: "UnansweredReviews",
    number: 1,
  },
  {
    type: "SpecialReviews",
    number: 1,
  },
  {
    type: "FailedComments",
    number: 1,
  },
];

export const review_appConnect = [
  {
    appName: "Baemin",
  },
  {
    appName: "Yogiyo",
  },
  {
    appName: "Coupangeats",
  },
];

export const review_AiCommentServiceSetting = {
  responseAfterNthDay: 4,
};

export const ceo_data = {
  ceoIdx: "",
  id: "",
  password: "",
  shopIdx: "",
  ceoType: "PREMIUM", // NORMAL PREMIUM
  canceledPremium: true,
  canceledPremiumDttm: date2Str(
    new Date(new Date().setDate(new Date().getDate() + 2))
  ),
  aiSettingTimePost: "NO_USE", // NO_USE, 1_DAY, 2_DAYS....
};

export const review_rating_chart = generateLatestSevenDays().map((x) => {
  return {
    label: x,
    rating5: Math.floor(Math.random() * 10),
    rating4: Math.floor(Math.random() * 10),
    rating3: Math.floor(Math.random() * 10),
    rating2: Math.floor(Math.random() * 10),
    rating1: Math.floor(Math.random() * 10),
    pendingComments: Math.floor(Math.random() * 10),
    unansweredReviews: Math.floor(Math.random() * 10),
    specialReviews: Math.floor(Math.random() * 10),
    failedComments: Math.floor(Math.random() * 10),
  };
});

export const review_reviewList2 = JSON.parse(
  "{\n" +
    '   "result_code": "결과코드[00000]",\n' +
    '   "result_msg": "결과메시지",\n' +
    '   "data": {\n' +
    '       "page_no": "요청페이지번호",\n' +
    '       "page_size": "페이지당게시물건수",\n' +
    '       "total_cnt": "총건수",\n' +
    '       "total_page_cnt": "총페이지수",\n' +
    '       "review_list": [{\n' +
    '           "order_no": "목록정렬순번",\n' +
    '           "platform_idx": "플랫폼일련번호",\n' +
    '           "platform_name": "플랫폼명",\n' +
    '           "platform_sub_idx": "하위플랫폼일련번호",\n' +
    '           "platform_sub_name": "하위플랫폼명",\n' +
    '           "partner_idx": "파트너일련번호",\n' +
    '           "partner_name": "파트너명",\n' +
    '           "manager_idx": "담당자일련번호",\n' +
    '           "manager_name": "담당자명",\n' +
    '           "shop_idx": "가맹점일련번호",\n' +
    '           "shop_name": "가맹점명",\n' +
    '           "app_idx": "배달앱일련번호",\n' +
    '           "app_name": "배달앱명",\n' +
    '           "store_idx": "매장일련번호",\n' +
    '           "store_name": "매장명",\n' +
    '           "review_idx": "리뷰일련번호",\n' +
    '           "ai_type1_comment_history_idx": "AI타입1댓글히스토리일련번호",\n' +
    '           "ai_type1_comment": "AI타입1댓글",\n' +
    '           "ai_type2_comment_history_idx": "AI타입2댓글히스토리일련번호",\n' +
    '           "ai_type2_comment": "AI타입2댓글",\n' +
    '           "ai_comment_modify_yn": "AI댓글수정여부",\n' +
    '           "ai_comment_use_yn": "AI댓글사용여부",\n' +
    '           "ai_comment_use_type_code": "AI댓글사용타입코드",\n' +
    '           "comment_reg_status_code": " ",\n' +
    '           "comment_reg_status": "답글등록상태",\n' +
    '           "comment_reg_result_msg": "답글등록결과메시지",\n' +
    '           "interest_review_message_yn": "관심리뷰메세지여부",\n' +
    '           "rating": "별점",\n' +
    '           "member_nickname": "리뷰회원닉네임",\n' +
    '           "important_yn": "관심리뷰여부",\n' +
    '           "images_url": "이미지목록",\n' +
    '           "menu_name": "메뉴명",\n' +
    '           "review_reg_dt": "배달앱리뷰등록일시",\n' +
    '           "blind_yn": "블라인드여부(Y/N)",\n' +
    '           "reg_dttm": "yyyyMMddHHmmss"\n' +
    "       }]\n" +
    "   }\n" +
    "}"
);
let reviewIdCount = 1;
const genDefaultReviewData = function (props) {
  return {
    reviewId: reviewIdCount++,
    reviewAt: "2023-08-11",
    customerName: "Customer 마츠모토쥰",
    appName: "Baemin",
    rating: 4.5,
    title: "[12345678] 추읍산 개군양평해장국 중동직영점",
    review:
      "CUSTOMER REVIEW CONTENT 쌈재료에 배추가 있는 곳은 처음 봤어요! 쌈재료도 다 싱싱하고 반찬들도 다 맛있고 양도 넉넉하고!막국수도 미니 사이즈도 아니고 맛있었어요",
    reviewResponse: "RESPONSE OF CEO OR AI 쌈재료에 배추가 있는",
    reviewResponsedAt: "2023-08-11",
    reviewStatus: "UNANSWERED",
    foodNames: ["어리굴젓보쌈(중 2~3인용)", "떡볶이(1인분)"],
    images: [],
    // foodStoreResponse: null,
    commentWillBePostedAt: null,
    isCommentPosting: false,
    isCommentExpired: false,
    foodStoreName: "FOOD STORE NAME",
    isCommentedByAI: false,
    ...props,
  };
};
export const reviewData = [
  genDefaultReviewData({
    reviewStatus: kUNANSWERED,
  }),
  genDefaultReviewData({
    reviewStatus: kPENDING,
    commentWillBePostedAt: date2Str(
      new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
    ),
  }),
  genDefaultReviewData({
    reviewStatus: kPENDING,
    isCommentPosting: true,
    isCommentedByAI: true,
  }),
  genDefaultReviewData({
    reviewStatus: kSUCCESS,
    isCommentedByAI: true,
  }),
  genDefaultReviewData({
    reviewStatus: kFAILED,
    isCommentExpired: false,
  }),
  genDefaultReviewData({
    reviewStatus: kFAILED,
    isCommentExpired: true,
  }),
  genDefaultReviewData({
    reviewStatus: kEXCLUDED,
  }),
  genDefaultReviewData({
    reviewStatus: kEXPIRED,
  }),
];

export const reviewSettingAdditionalCommentData = [
  {
    rascId: 1,
    rsacTitle: "TITLE1: 제목이 최대 50자 까지 줄바꿈 없이 들어갑니다",
    rsacContent: "CONTENT1: 제목이 최대 50자 까지 줄바꿈 없이 들어갑니다",
    rsacStoreIds: [1],
  },
  {
    rascId: 2,
    rsacTitle: "TITLE2: 제목이 최대 50자 까지 줄바꿈 없이 들어갑니다",
    rsacContent: "CONTENT2: 제목이 최대 50자 까지 줄바꿈 없이 들어갑니다",
    rsacStoreIds: [2, 3],
  },
];

export const reviewSettingDaysData = {
  rsdDays: "NO_USE",
};

export const ceoStoreData = [
  {
    rsacStoreId: 1,
    rsacStoreName: "FOOD STORE NAME 1",
    rsacAppName: "Baemin",
  },
  {
    rsacStoreId: 2,
    rsacStoreName:
      "[배달의민족] 12345678 추읍산 개군양평해장국 중동직영점 [배달의민족] 추읍산 개군양평해장국 중동직영점",
    rsacAppName: "Baemin",
  },
  {
    rsacStoreId: 3,
    rsacStoreName: "FOOD STORE NAME 3",
    rsacAppName: "Yogiyo",
  },
];




export const analytic_ranking = [
  {
      "label": "7월",
      "month": 7,
      "value": 4.4,
  },
 
]

export const analytic_rating = [
  {
      "label": "7월",
      "month": 7,
      "value": 1384,
  },
]

export const analytic_cares = [
  {
      "label": "7월",
      "month": 7,
      "value": 0,
  },
]